import { observer } from "mobx-react";

import { CashoutType } from "@gp/hub";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import React, { useContext } from "react";
import classnames from "classnames";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import CashoutButtonCore from "@features/my-bets/shared/cashout/CashoutButtonCore";

export const BetDetailsCashOutButton = observer(
	function BetDetailsCashOutButton(props: {
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
	}) {
		const { store } = props;

		let cashoutStore: CashoutStore;

		if (store instanceof BetSlipReceiptModalStore) {
			cashoutStore = store.cashoutStore;
		} else {
			cashoutStore = store.myBetsStore.cashoutStore;
		}

		const bet = useContext(MyBetsBetContext);

		if (bet.isCashoutUnavailable) {
			return null;
		}

		const buttonClassNames = classnames(
			"bet__btn__split__quote btn btn--med btn--block btn--ghost",
			{
				"btn--icon inc": bet.indicator > 0,
				"btn--icon desc": bet.indicator < 0,
			}
		);

		const iconClassNames = classnames("", {
			"u-icon u-icon--tny u-icon--caret--up u-color--core--snow":
				bet.indicator > 0,
			"u-icon u-icon--tny u-icon--caret--down u-color--core--snow":
				bet.indicator < 0,
		});

		return (
			<button
				type="button"
				className={buttonClassNames}
				onClick={() =>
					store.openCashout({
						userId: bet.userId || "",
						id: bet.id,
						displayedAmount: "",
						calculatedCashoutAmount: bet.calculatedCashoutAmount,
						cType: bet.cType || CashoutType.NO_CACHE_OUT,
						isChangeAccepted: false,
						isLive: bet.isLive,
						liveBetSlipCountdown: bet.liveBetSlipCountdown,
					})
				}
				disabled={cashoutStore.isCashoutFormSubmitting}
			>
				<i className={iconClassNames}></i>
				<CashoutButtonCore />
			</button>
		);
	}
);
